import script from "./ScrollToButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToButton.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToButton.vue?vue&type=style&index=0&id=b66ba268&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b66ba268"]])

export default __exports__